$ = require 'jquery'
AttachmentHelpers = require './helpers'
Dates = require 'lib/dates'
Keys = require 'data/keys'
PluginModelSerializer = require 'views/internal/plugins/plugin-model-serializer'
PluginRunner = require 'views/internal/plugins/plugin-runner'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
UserInput = require 'views/internal/user-input'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class AttachmentViewerView extends View

  className: 'attachment-viewer'

  initialize: ->
    PopOver.hide()
    @allowsCardCovers = @model.getBoard()?.getPref('cardCovers')
    @currentAttachment = @options.attachmentModel
    idAtt = @options.idAttachment
    if idAtt?
      @currentAttachment = @model.attachmentList.find( (model) -> model.id == idAtt)

    @idPluginAttachments = []
    @getIdPluginAttachments()

    @idTrelloAttachments = []
    @getIdTrelloAttachments()

    @listenTo @model.attachmentList, 'add remove reset', @getIdPluginAttachments

  events:
    'click .js-show-next-frame': 'showNextFrame'
    'click .js-show-prev-frame': 'showPrevFrame'
    'mouseenter .js-show-next-frame': 'hintNextFrame'
    'mouseenter .js-show-prev-frame': 'hintPrevFrame'

    'mouseleave .js-show-next-frame': 'clearHint'
    'mouseleave .js-show-prev-frame': 'clearHint'

    'click .js-stop': 'stop'
    'click .js-close-viewer': 'close'

    'click .js-open-delete-confirm': 'openDeleteConfirm'
    'click .js-close-delete-confirm': 'closeDeleteConfirm'
    'click .js-delete': 'delete'
    'click .js-make-cover': 'makeCover'
    'click .js-remove-cover': 'removeCover'

    'shortcut': 'shortcut'

  shortcut: (key) ->

    switch key
      when Keys.Escape
        @close()
        ["Esc - Close Attachment Viewer", "Attachment Viewer"]

      when Keys.ArrowRight
        @showNextFrame()
        ["Right Arrow - Next Attachment", "Attachment Viewer"]

      when Keys.ArrowLeft
        @showPrevFrame()
        ["Left Arrow - Previous Attachment", "Attachment Viewer"]

  # getters
  getAttachmentModels: ->
    @model.attachmentList.filter (attachment) =>
      attachment.id not in @idPluginAttachments and attachment.id not in @idTrelloAttachments

  getAttachmentModelsLength: -> @getAttachmentModels().length

  getCurrentAttachmentIndex: ->
    _.indexOf(@getAttachmentModels(), @currentAttachment)


  # NOTE: Prev increments and Next decrements because attachments are
  #       reverse sorted on the card back (descending `pos` order). Thus,
  #       pressing the right arrow key (next) should iterate *down*
  #       the list, and the left arrow key (prev) should go iterate *up*
  getPrevAttachmentIndex: ->
    idx = @getCurrentAttachmentIndex() + 1
    if idx >= @getAttachmentModelsLength() then null else idx

  getPrevModel: ->
    idx = @getPrevAttachmentIndex()
    if idx? then @getAttachmentModels()[idx] else null

  getNextAttachmentIndex: ->
    idx = @getCurrentAttachmentIndex() - 1
    if idx < 0 then null else idx

  getNextModel: ->
    idx = @getNextAttachmentIndex()
    if idx? then @getAttachmentModels()[idx] else null


  render: ->
    data = @model.toJSON()
    data.numAttachments = @getAttachmentModelsLength()

    @$el.html(
      templates.fill(
        'attachment_viewer',
        data
      )
    )

    if @currentAttachment.id in @idPluginAttachments
      models = @getAttachmentModels()
      @currentAttachment = models[models.length - 1]

    @addNewFrame(@currentAttachment, 'center')

    nextModel = @getNextModel()
    if nextModel?
      @addNewFrame(nextModel, 'right')

    prevModel = @getPrevModel()
    if prevModel?
      @addNewFrame(prevModel, 'left')

    @setDetailsAndControls()

    UserInput.addHandler @,
      scope: 'attachment_viewer'
      modal: true

    @

  setDetailsAndControls: ->
    AttachmentHelpers.getAttachmentData(@currentAttachment)
    .then (data) =>
      data.canMakeCover = @allowsCardCovers && data.previews?.length > 0
      data.isCover = @allowsCardCovers && @model.get('idAttachmentCover') == @currentAttachment.id

      babbleKey = if @currentAttachment.get('isUpload')
        'delete attachment'
      else
        'remove attachment'

      _.extend data,
        removeButtonText: l([babbleKey, 'button'])
        removeMessageText: l([babbleKey, 'message'])
        removeConfirmText: l([babbleKey, 'confirm'])
        removeCancelText: l([babbleKey, 'cancel'])

      @$('.js-display-frame-details').html(
        templates.fill(
          'attachment_viewer_frame_details',
          data,
          { editable: @model.editable() }
        )
      )

      @$('.js-show-prev-frame').toggleClass('hide', !@getPrevAttachmentIndex()?)
      @$('.js-show-next-frame').toggleClass('hide', !@getNextAttachmentIndex()?)

      Dates.update(@el)
    .done()

    return

  addNewFrame: (model, direction) ->
    AttachmentHelpers.getAttachmentData(model)
    .then (data) =>
      if direction?
        data.directionClass = "attachment-viewer-frame-#{direction}"

      isImagePreviewable = (data.ext in AttachmentHelpers.imageExts()) || (data.previews?.length > 0)
      isAudioable = (data.ext in AttachmentHelpers.audioExts())
      isVideoable = (data.ext in AttachmentHelpers.videoExts())
      isIFrameable = (data.ext in AttachmentHelpers.iFrameableExts())
      isGoogleViewerable = (data.ext in AttachmentHelpers.googleViewerableExts())

      if data.isExternal
        data.isPlaceholder = true
      else if isImagePreviewable
        data.isImage = true
        # HACK: We're preferring to use a preview over the default attachment
        # URL because the preview selection will try to avoid versions of the
        # image that have an EXIF rotation set
        if data.previews? && (previewURL = Util.biggestPreview(data.previews)?.url)?
          data.url = previewURL
      else if isAudioable
        data.isAudio = true
      else if isVideoable
        data.isVideo = true
      else if isIFrameable
        data.isIFrameable = true
      else if isGoogleViewerable
        data.isIFrameable = true
        urlParam = encodeURIComponent(data.url)
        data.url = "https://docs.google.com/viewer?embedded=true&url=#{urlParam}"
      else
        data.isPlaceholder = true
        data.openText = "Download"

      @$('.js-frames').append(
        templates.fill(
          'attachment_viewer_frame',
          data,
          { editable: @model.editable() }
        )
      )

      # because
      @defer ->
        $('.attachment-viewer-frame').addClass('attachment-viewer-frame-loaded')
    .done()

    @

  focusFrame: (model, direction) ->
    @currentAttachment = model
    focusFrame = _.find @$('.attachment-viewer-frame'), (frame) => $(frame).attr('data-idAttachment') == model.id

    switch direction
      when 'right'
        frameToRemove = @$('.attachment-viewer-frame-left')
        oldFocusFrameClass = 'attachment-viewer-frame-left'
        modelForNewFrame = @getNextModel()
      when 'left'
        frameToRemove = @$('.attachment-viewer-frame-right')
        oldFocusFrameClass = 'attachment-viewer-frame-right'
        modelForNewFrame = @getPrevModel()

    # the old center frame needs to be shifted.
    @$('.attachment-viewer-frame-center')
    .removeClass('attachment-viewer-frame-center')
    .addClass(oldFocusFrameClass)

    # center the new current frame
    $(focusFrame)
    .removeClass('attachment-viewer-frame-left attachment-viewer-frame-right')
    .addClass('attachment-viewer-frame-center')

    # only three frames. remove one.
    frameToRemove.remove()

    # add a new frame. if there is no model for the frame (i.e. we are at the
    # end or beginning), then add a blank frame as a buffer.
    if modelForNewFrame?
      @addNewFrame(modelForNewFrame, direction)
    else
      @clearHint()

    @setDetailsAndControls()

    return

  showNextFrame: (e) ->
    Util.stop(e)
    model = @getNextModel()
    if model?
      @focusFrame(model, 'right')
    track("Attachment Viewer", "Show Next Frame")
    return

  showPrevFrame: (e) ->
    Util.stop(e)
    model = @getPrevModel()
    if model?
      @focusFrame(model, 'left')
    track("Attachment Viewer", "Show Previous Frame")
    return

  hintNextFrame: ->
    @$el.addClass('attachment-viewer-frames-next-hint')
    return

  hintPrevFrame: ->
    @$el.addClass('attachment-viewer-frames-prev-hint')
    return

  clearHint: ->
    @$el.removeClass('attachment-viewer-frames-next-hint attachment-viewer-frames-prev-hint')
    return

  stop: (e) ->
    Util.stopPropagation(e)

  openDeleteConfirm: (e) ->
    Util.stop(e)
    @$('.js-meta').addClass('hide')
    @$('.js-confirm-delete').removeClass('hide')
    track("Attachment Viewer", "Open Delete Attachment Confirm")
    return

  closeDeleteConfirm: (e) ->
    Util.stop(e)
    @$('.js-meta').removeClass('hide')
    @$('.js-confirm-delete').addClass('hide')
    track("Attachment Viewer", "Close Delete Attachment Confirm")
    return

  delete: (e) ->
    Util.stop(e)
    @currentAttachment.destroy()
    @close()
    track("Attachment Viewer", "Delete Attachment")
    return

  renderToggleCover: ->
    canMakeCover = @allowsCardCovers && @currentAttachment.get('previews').length > 0
    @$('.js-cover-options').toggleClass('hide', !canMakeCover)

    isCover = @allowsCardCovers && @model.get('idAttachmentCover') == @currentAttachment.id
    @$('.js-make-cover-box').toggleClass('hide', isCover)
    @$('.js-remove-cover-box').toggleClass('hide', !isCover)

    return

  makeCover: ->
    @model.makeCover(@currentAttachment)
    @renderToggleCover()
    track("Attachment Viewer", "Make Cover")
    return

  removeCover: ->
    @model.removeCover(null)
    @renderToggleCover()
    track("Attachment Viewer", "Remove Cover")
    return

  close: ->
    @remove()
    UserInput.removeHandler @
    track("Attachment Viewer", "Close Viewer")
    return

  getIdPluginAttachments: ->
    @getIdTrelloAttachments()

    PluginRunner.all
      timeout: 5000
      command: 'attachment-sections'
      card: @model
      board: @model.getBoard()
      options:
        entries: PluginModelSerializer.attachments(@model.attachmentList)
    .then (pluginAttachments) =>
      @idPluginAttachments = _.chain(pluginAttachments).map(
        (section) ->
          section?.claimed?.map(
            (attachment) ->
              attachment.id
          )
      ).flatten().value()

      @render()

  getIdTrelloAttachments: ->
    Promise.map(@model.attachmentList.models, AttachmentHelpers.getAttachmentData)
      .then (allAttachmentData) =>
        @idTrelloAttachments = _.chain(allAttachmentData).filter (attachmentData) ->
          attachmentData.isKnownService and attachmentData.type in ['trello card', 'trello board']
        .map ({ id }) -> id
        .value()



// WEBPACK FOOTER //
// ./app/scripts/views/attachment/attachment-viewer-view.coffee